import React, { Component } from 'react'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { extendObservable, intercept } from 'mobx'
import styled, { keyframes } from 'styled-components'
import { TweenMax } from 'gsap'
import LockWhiteIcon from '@/assets/images/icon-lock-white.svg'
import PendingIndicatorIcon from '@/assets/images/pending-indicator.svg'
import NextIcon from '@/assets/images/play-next.svg'
import UpArrowIcon from '@/assets/images/preplay-up-arrow-black.webp'
import ReactQuill, { Quill } from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import DDColor from '@/Components/CommandHost/Common/DDColor'
import DDFont from '@/Components/CommandHost/Common/DDFont'
import DDAnnounceSponsor from '@/Components/CommandHost/Common/DDAnnounceSponsor'
import { vhToPx } from '@/utils'
import { responsiveDimension } from '../../utils'
import AnnouncementTimer from './Common/AnnouncementTimer'

@inject(
  'PrePlayStore',
  'PlayStore',
  'GameStore',
  'CommandHostStore',
  'AutomationStore'
)
@observer
export default class AnnounceItemPreLoad extends Component {
  constructor(props) {
    super(props)
    FONT_SIZE = this.props.CommandHostStore.fontSize + 'vh'
    extendObservable(this, {
      promptRemove: false,
      quillHeader: null,
      quillMiddle: null,
      quillBottom: null,
      reference: `announce-editor-${this.props.currentStack}-${this.props.item.index}`,
    })
    this._isMounted = false
    this.hasChanges = false
    this.headerInputId = 'announce-header-editor'
    this.sourceAnnouncements = [].concat(this.props.item.announcements)

    //AUTOMATION
    if (
      this.props.GameStore.executionType === 'recording' &&
      this.props.PrePlayStore.sessionButtons['start'] &&
      (
        this.props.PrePlayStore.sessionButtons['start'].text || ''
      ).toLowerCase() === 'resume session'
    ) {
      this.state = {
        sessionStarted: false,
        haveUpdated: [],
        announcementHasChanges: false,
      }
    } else {
      this.state = {
        sessionStarted: this.props.GameStore.isSessionStarted,
        haveUpdated: [],
        announcementHasChanges: false,
      }
    }

    this.destroyProgress = intercept(
      this.props.GameStore,
      'progress',
      change => {
        this.setState({ sessionStarted: change.newValue === 'live' })
        return change
      }
    )

    this.destroySessionMode = intercept(
      this.props.GameStore,
      'sessionMode',
      change => {
        this.setState({ sessionStarted: change.newValue === 1 })
        return change
      }
    )
  }

  handleGoClick(itemId, refId) {
    this.props.AutomationStore.addEvent({
      evt: 'click',
      refId: refId,
      wait: 1,
      playId: this.props.item.id,
    })

    if (this[`next-play-go-${itemId}`]) {
      TweenMax.set(this[`next-play-go-${itemId}`], { display: 'none' })
      TweenMax.set(this[`next-play-indicator-go-${itemId}`], {
        display: 'flex',
      })
    }
    if (this.isGmAnnouncement(this.props.item)) {
      let stringifiedAsset = JSON.stringify(this.parsedVideoInfo)
      this.props.item.announcements[2].value =
        stringifiedAsset + this.props.item.announcements[2].value
      if (this.parsedVideoInfo)
        this.props.GameStore.updateGmAssetQuantity(
          this.parsedVideoInfo.id,
          this.parsedVideoInfo.quantity - 1
        )
    }
    this.props.go(this.props.item)
  }

  handleRemoveClick(refId) {
    //this.props.AutomationStore.addEvent({evt:'click', refId: refId, wait: 2, playId: this.props.item.id})
    this.promptRemove = true
    this.forceUpdate()
    setTimeout(() => {
      this.promptRemove = false
      if (this._isMounted) {
        this.forceUpdate()
      }
    }, 3000)
  }

  handleUpdateChanges(force) {
    if (force) {
      /*
      //tmp to delete
      this.props.item.multiplierChoices[0].question = await (this.props.item
        .playTitle && this.props.item.playTitle.value
        ? this.props.item.playTitle.value
        : ''
      ).toLowerCase() */
      this.props.gamesUpdate(this.props.item)
      this.initInitialValues()
      this.setState({
        haveUpdated: [],
        announcementHasChanges: false,
      })
      this.forceUpdate()
    }
  }

  handlePromptRemoveClick(refId) {
    //this.props.AutomationStore.addEvent({evt:'click', refId: refId, wait: 1, playId: this.props.item.id})

    this.props.item.executionType = (
      this.props.GameStore.executionType || ''
    ).toLowerCase()
    this.props.remove(this.props.item)
  }

  handlePromptRemoveClickX1() {
    this.props.removeNextPlay()
  }

  isValuesChanged = () => {
    try {
      const isHeaderChanged =
        this.initialValues.header.content !==
        this.quillHeader.root.innerHTML.toString().replace(/(<([^>]+)>)/gi, '')
      const isHeaderSelected =
        this.quillHeader.getSelection() &&
        this.quillHeader.getSelection().length > 0
      const isMiddleChanged =
        this.initialValues.middle.content.toString().trim() !==
        this.quillMiddle.root.innerHTML
          .toString()
          .replace(/(<([^>]+)>)/gi, '')
          .trim()
      const isMiddleSelected =
        this.quillMiddle.getSelection() &&
        this.quillMiddle.getSelection().length > 0
      return {
        isHeaderChanged,
        isMiddleChanged,
        isHeaderSelected: false,
        isMiddleSelected: false,
      }
    } catch (e) {
      console.log({ e })
      return {}
    }
  }

  toggleEditor(area, mode, editor, editorReadOnly) {
    if (mode === 'editing') {
      if (this.updateTimeout) {
        clearTimeout(this.updateTimeout)
      }
      const e = document.getElementsByClassName(editor)
      const ero = document.getElementsByClassName(editorReadOnly)
      TweenMax.set(e, { display: 'block' })
      TweenMax.set(ero, { display: 'none' })
      if (area === 'header') {
        this.quillHeader.focus()
      }
      if (area === 'middle') {
        this.quillMiddle.focus()
      }
      this.setState({
        haveUpdated: [...this.state.haveUpdated, area],
      })
    } else {
      const e = document.getElementsByClassName(editor)
      const ero = document.getElementsByClassName(editorReadOnly)
      TweenMax.set(e, { display: 'none' })
      TweenMax.set(ero, { display: 'flex' })

      if (e) {
        TweenMax.set(e, { display: 'none' })
      }
      if (ero) {
        TweenMax.set(ero, { display: 'flex' })
      }
      const {
        isHeaderChanged,
        isHeaderSelected,
        isMiddleChanged,
        isMiddleSelected,
      } = this.isValuesChanged()
      this.setState({
        announcementHasChanges: isHeaderChanged || isMiddleChanged,
      })
      if (area === 'header' && !isHeaderSelected && !isHeaderChanged) {
        this.quillHeaderColor = window.getComputedStyle(ero[0]).color
        this.updateTimeout = setTimeout(() => {
          this.setState({
            haveUpdated: this.state.haveUpdated.filter(i => i !== area),
          })
        }, 500)
      }

      if (area === 'middle' && !isMiddleSelected && !isMiddleChanged) {
        this.updateTimeout = setTimeout(() => {
          this.setState({
            haveUpdated: this.state.haveUpdated.filter(i => i !== area),
          })
        }, 500)
      }

      setTimeout(() => {
        if (area === 'header') {
          this.props.item.announcements[0].value = this.quillHeader.root.innerHTML
          ero[0].innerHTML = this.quillHeader.root.innerHTML
          if (ero && ero[0]) {
            ero[0].innerHTML = this.quillHeader.root.innerHTML
          }
          this.quillHeader.blur()
        }
        if (area === 'middle') {
          this.props.item.announcements[1].value = this.quillMiddle.root.innerHTML
          ero[0].innerHTML = this.quillMiddle.root.innerHTML
          if (ero && ero[0]) {
            ero[0].innerHTML = this.quillMiddle.root.innerHTML
          }
          this.quillMiddle.blur()
        }
        if (area === 'bottom') {
          this.props.item.announcements[2].value = this.quillBottom.root.innerHTML
          ero[0].innerHTML = this.quillBottom.root.innerHTML
          if (ero && ero[0]) {
            ero[0].innerHTML = this.quillBottom.root.innerHTML
          }
          this.quillBottom.blur()
        }
        this.forceUpdate()
      }, 0)
    }
  }

  handleColorValue(newColor, area) {
    if (area === 'header') {
      if (
        this.quillHeader.getSelection() &&
        this.quillHeader.getSelection().length > 0
      ) {
        let index = this.quillHeader.getSelection().index
        let length = this.quillHeader.getSelection().length
        this.quillHeader.formatText(index, length, 'color', newColor, true)

        this.props.item.announcements[0].color = newColor
      }
      this.quillHeader.format('color', newColor)
      if (this.initialValues.header.color !== newColor) {
        this.setState({
          announcementHasChanges: true,
        })
      }
      this.quillHeaderColor = newColor

      /**
       * added this line to update the ReadOnly Editor immediately when the Quill Editor has triggered the blur event.
       */
      this.props.item.announcements[0].value = this.quillHeader.root.innerHTML
      const ero = document.getElementsByClassName(
        `${this.reference}-header-preload-readonly`
      )
      ero[0].innerHTML = this.quillHeader.root.innerHTML
    }

    if (area === 'middle') {
      if (this.quillMiddle.getSelection()) {
        let index = this.quillMiddle.getSelection().index
        let length = this.quillMiddle.getSelection().length
        this.quillMiddle.formatText(index, length, 'color', newColor, true)

        this.props.item.announcements[1].color = newColor
      }
      this.quillMiddle.format('color', newColor)
      if (this.initialValues.middle.color !== newColor) {
        this.setState({
          announcementHasChanges: true,
        })
      }
      this.quillMiddleColor = newColor

      /**
       * added this line to update the ReadOnly Editor immediately when the Quill Editor has triggered the blur event.
       */
      this.props.item.announcements[1].value = this.quillMiddle.root.innerHTML
      const ero = document.getElementsByClassName(
        `${this.reference}-middle-preload-readonly`
      )
      ero[0].innerHTML = this.quillMiddle.root.innerHTML
    }

    if (area === 'bottom') {
      if (this.quillBottom.getSelection()) {
        let index = this.quillBottom.getSelection().index
        let length = this.quillBottom.getSelection().length
        this.quillBottom.formatText(index, length, 'color', newColor, true)

        this.props.item.announcements[2].color = newColor
      }
    }
  }

  handleFontValue(newFont, area) {
    if (area === 'header') {
      if (this.quillHeader.getSelection()) {
        let index = this.quillHeader.getSelection().index
        let length = this.quillHeader.getSelection().length
        let selectedText = this.quillHeader.getText(index, length)
        this.quillHeader.formatText(index, length, 'font', newFont, true)

        this.props.item.announcements[0].font = newFont
      }
      this.quillHeader.format('font', newFont)
      if (this.initialValues.header.font !== newFont) {
        this.quillHeaderFont = newFont
        this.setState({
          announcementHasChanges: true,
        })
      }

      /**
       * added this line to update the ReadOnly Editor immediately when the Quill Editor has triggered the blur event.
       */
      this.props.item.announcements[0].value = this.quillHeader.root.innerHTML
      const ero = document.getElementsByClassName(
        `${this.reference}-header-preload-readonly`
      )
      ero[0].innerHTML = this.quillHeader.root.innerHTML
    }

    if (area === 'middle') {
      if (this.quillMiddle.getSelection()) {
        let index = this.quillMiddle.getSelection().index
        let length = this.quillMiddle.getSelection().length
        let selectedText = this.quillMiddle.getText(index, length)
        this.quillMiddle.formatText(index, length, 'font', newFont, true)

        this.props.item.announcements[1].font = newFont
      }
      this.quillMiddle.format('font', newFont)
      if (this.initialValues.middle.font !== newFont) {
        this.quillMiddleFont = newFont
        this.setState({
          announcementHasChanges: true,
        })
      }
      /**
       * added this line to update the ReadOnly Editor immediately when the Quill Editor has triggered the blur event.
       */
      this.props.item.announcements[1].value = this.quillMiddle.root.innerHTML
      const ero = document.getElementsByClassName(
        `${this.reference}-middle-preload-readonly`
      )
      ero[0].innerHTML = this.quillMiddle.root.innerHTML
    }

    if (area === 'bottom') {
      if (this.quillBottom.getSelection()) {
        let index = this.quillBottom.getSelection().index
        let length = this.quillBottom.getSelection().length
        let selectedText = this.quillBottom.getText(index, length)
        this.quillBottom.formatText(index, length, 'font', newFont, true)

        this.props.item.announcements[2].font = newFont
      }
    }
  }

  handleSelectedSponsor(val, isAutomatic) {
    if (!this.props.item.pmetadata) this.props.item.pmetadata = {}
    if (typeof this.props.item.pmetadata === 'string') {
      try {
        this.props.item.pmetadata = JSON.parse(this.props.item.pmetadata)
      } catch (e) {
        this.props.item.pmetadata = {}
      }
    }
    if (!this.props.item.pmetadata.public) this.props.item.pmetadata.public = {}

    if (isAutomatic === 'Undo') {
      this.props.item.sponsor = null
      this.props.item.sponsorId = 0
      this.props.item.assetSetId = 0
      delete this.props.item.resolvedSponsorId
      delete this.props.item.resolvedBrandId
      delete this.props.item.resolvedAssetSetId

      this.props.item.pmetadata.isManualOverride = false
      this.props.item.pmetadata.isAutomatic = true
      delete this.props.item.pmetadata.resolvedSponsorId
      delete this.props.item.pmetadata.resolvedBrandId
      delete this.props.item.pmetadata.resolvedAssetSetId
      delete this.props.item.pmetadata.placement_subbrand_text

      this.props.item.pmetadata.public.isManualOverride = false
      this.props.item.pmetadata.public.isAutomatic = true
      delete this.props.item.pmetadata.public.resolvedSponsorId
      delete this.props.item.pmetadata.public.resolvedBrandId
      delete this.props.item.pmetadata.public.resolvedAssetSetId
      delete this.props.item.pmetadata.public.placement_subbrand_text

      this.setState({
        announcementHasChanges: true,
      })
    } else {
      this.props.item.pmetadata.isManualOverride = true
      this.props.item.pmetadata.isAutomatic = false
      this.props.item.pmetadata.public.isManualOverride = true
      this.props.item.pmetadata.public.isAutomatic = false
    }

    let hasSponsorChange = false
    if (val && val.sponsorItem) {
      const oldBrandId =
        this.props.item.sponsor && this.props.item.sponsor.sponsorItem
          ? this.props.item.sponsor.sponsorItem.brandId
          : this.props.item.sponsorId
      const oldAssetSetId =
        this.props.item.sponsor && this.props.item.sponsor.sponsorItem
          ? this.props.item.sponsor.sponsorItem.assetSetId
          : this.props.item.assetSetId
      if (
        oldBrandId !== val.sponsorItem.brandId ||
        oldAssetSetId !== val.sponsorItem.assetSetId
      ) {
        hasSponsorChange = true
      }
    }

    if (hasSponsorChange) {
      this.setState({
        announcementHasChanges: true,
      })
    } else if (this.props.item.sponsorId !== 0 && isAutomatic === 'Default') {
      this.setState({
        announcementHasChanges: true,
      })
    } else if (this.state.haveUpdated && this.state.haveUpdated.length === 0) {
      this.setState({
        announcementHasChanges: false,
      })
    }
    this.props.item.sponsor = val
    this.props.item.sponsorExpanded = false
    if (!val) {
      this.sponsorEnable(0, false)
    }
    const previewItem = Object.assign({}, this.props.item)
    this.props.GameStore.setAnnouncementValueObservable(previewItem)

    this.forceUpdate()

    if (isAutomatic === 'Undo') {
      if (this.handleUpdateChanges) {
        setTimeout(() => {
          this.handleUpdateChanges(true)
        }, 0)
      }
    }
  }

  handleSponsorClick() {
    this.sponsorEnable(1, true)
    this.forceUpdate()
  }

  sponsorEnable(val, isExpanded) {
    if (val === 1) {
      const bottomEditorReadOnly = document.getElementsByClassName(
        `${this.reference}-bottom-preload-readonly`
      )
      const bottomEditor = document.getElementsByClassName(
        `${this.reference}-bottom-preload`
      )
      const bottomSponsor = document.getElementsByClassName(
        `${this.reference}-sponsor`
      )
      if (bottomEditorReadOnly && bottomEditor && bottomSponsor) {
        TweenMax.set(bottomEditorReadOnly, { display: 'none' })
        TweenMax.set(bottomEditor, { display: 'none' })
        TweenMax.set(bottomSponsor, { display: 'block' })
        if (bottomSponsor) {
          this.props.item.sponsorExpanded = isExpanded
        }
      } else {
        const bottomEditorReadOnly = document.getElementsByClassName(
          `${this.reference}-bottom-preload-readonly`
        )
        const bottomEditor = document.getElementsByClassName(
          `${this.reference}-bottom-preload`
        )
        const bottomSponsor = document.getElementsByClassName(
          `${this.reference}-sponsor`
        )
        if (bottomEditorReadOnly && bottomEditor && bottomSponsor) {
          TweenMax.set(bottomEditorReadOnly, { display: 'flex' })
          TweenMax.set(bottomEditor, { display: 'none' })
          TweenMax.set(bottomSponsor, { display: 'none' })
        }
      }
    }
  }

  async initValues(item = this.props.item) {
    this.quillHeader.root.innerHTML = item.announcements[0].value
    this.quillMiddle.root.innerHTML = item.announcements[1].value
    this.quillBottom.root.innerHTML = item.announcements[2].value
    const isGMAnnounce = this.isGmAnnouncement(item)
    let bottomValue = ''
    if (isGMAnnounce) {
      const videoInfo =
        item.announcements[2].value.match(/{[^{}]*}/) &&
        item.announcements[2].value.match(/{[^{}]*}/)[0]
      this.parsedVideoInfo = JSON.parse(videoInfo)
      bottomValue = item.announcements[2].value.replace(videoInfo, '')
    }
    document.getElementsByClassName(
      `${this.reference}-header-preload-readonly`
    )[0].innerHTML = item.announcements[0].value
    document.getElementsByClassName(
      `${this.reference}-middle-preload-readonly`
    )[0].innerHTML = item.announcements[1].value
    document.getElementsByClassName(
      `${this.reference}-bottom-preload-readonly`
    )[0].innerHTML = item.announcements[2].value
    this.setState({ sponsors: this.props.PrePlayStore.sponsors })
    this.initInitialValues(item)

    //TODO:
    // this.quillHeader.on('text-change', async () => {
    //  const { isHeaderChanged, isMiddleChanged } = this.isValuesChanged()
    //  this.setState({
    //   announcementHasChanges: isHeaderChanged || isMiddleChanged
    //  })
    // })
  }

  initInitialValues = (item = this.props.item) => {
    const [header = {}, middle = {}] = item.announcements || []
    this.quillHeaderColor = header.color //|| '#17c4fe'
    this.quillHeaderFont = header.font //|| 'pamainebold'
    this.quillMiddleColor = middle.color //||  '#ffb600'
    this.quillMiddleFont = middle.font //|| 'pamainextrabold'

    this.initialValues = {
      header: {
        content: this.quillHeader.root.innerHTML
          .toString()
          .replace(/(<([^>]+)>)/gi, ''),
        font: this.quillHeaderFont,
        color: this.quillHeaderColor,
      },
      middle: {
        content: this.quillMiddle.root.innerHTML
          .toString()
          .replace(/(<([^>]+)>)/gi, ''),
        font: this.quillMiddleFont,
        color: this.quillMiddleColor,
      },
    }
  }

  isGmAnnouncement(item) {
    return item.subType && item.subType.includes('gm_announce')
  }

  gMAnnouncePlayTitle(item, index) {
    let title =
      item && item.subType && item.subType.includes('msg')
        ? 'MES VID'
        : 'GM MES'
    return title.split(' ')[index]
  }

  getPresetName(item) {
    const parser = new DOMParser()
    let videoInfo =
      item.announcements[2].value.match(/{[^{}]*}/) &&
      item.announcements[2].value.match(/{[^{}]*}/)[0]
    this.parsedVideoInfo = JSON.parse(videoInfo)
    return this.parsedVideoInfo && this.parsedVideoInfo.name
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.item !== this.props.item) {
      this.initValues(nextProps.item)
    }
  }

  componentWillUnmount() {
    this._isMounted = false
    this.destroyProgress()
    this.destroySessionMode()
  }

  async componentDidMount() {
    this._isMounted = true
    let Font = Quill.import('formats/font')
    Font.whitelist = [
      'pamainlight',
      'pamainregular',
      'pamainbold',
      'pamainextrabold',
    ]
    Quill.register(Font, true)

    this.quillHeader = new Quill(`.${this.reference}-header-preload`, {
      modules: {
        toolbar: false,
      },
      theme: 'snow',
    })

    this.quillMiddle = new Quill(`.${this.reference}-middle-preload`, {
      modules: {
        toolbar: false,
      },
      theme: 'snow',
    })

    this.quillBottom = new Quill(`.${this.reference}-bottom-preload`, {
      modules: {
        toolbar: false,
      },
      theme: 'snow',
    })

    const previewItem = await Object.assign({}, this.props.item)
    this.props.GameStore.setAnnouncementValueObservable(previewItem)

    this.initValues()

    // old
    // if (this.props.item.sponsor && this.props.item.sponsor.id) {
    //   this.sponsorEnable(1, false)
    // } else {
    //   this.sponsorEnable(0, false)
    // }

    //new
    if (
      this.props.item.sponsor &&
      this.props.item.sponsor.sponsorCategory &&
      this.props.item.sponsor.sponsorItem &&
      this.props.item.sponsor.sponsorItem.brandId
    ) {
      this.sponsorEnable(1, false)
    } else {
      this.sponsorEnable(0, false)
    }

    delete this.props.item.editorEvents
    delete this.props.item.recordedAutomation
  }

  render() {
    let { item, index, GameStore, zIndexIndex } = this.props
    if (!item) return null
    let { sessionStarted } = this.state
    let required = false
    const editorReadOnly1Announce = `editor-readonly-1-Announce-${this.props.AutomationStore.playSequence}`
    const editorReadOnly2Announce = `editor-readonly-2-Announce-${this.props.AutomationStore.playSequence}`
    const editorReadOnly3Announce = `editor-readonly-3-Announce-${this.props.AutomationStore.playSequence}`

    const editor1Announce = `editor-1-Announce-${this.props.AutomationStore.playSequence}`
    const editor2Announce = `editor-2-Announce-${this.props.AutomationStore.playSequence}`
    const editor3Announce = `editor-3-Announce-${this.props.AutomationStore.playSequence}`
    const isGMAnnounce = this.isGmAnnouncement(item)
    const presetName = isGMAnnounce ? this.getPresetName(item) : ''

    return (
      <Container zIndex={1000 - zIndexIndex}>
        <Main>
          <PlayStatusWrapper backgroundColor={'#a7a9ac'} src={NextIcon} />
          <PlayTypeDD>
            <PrePlaySequence
              backgroundColor={isGMAnnounce ? '#19d1bf' : '#231f20'}
              text={`${item.sequence}`}
            />
            {isGMAnnounce ? (
              <PrePlaySingle backgroundColor={'#19d1bf'}>
                <span
                  style={{ whiteSpace: 'break-spaces' }}
                >{`${this.gMAnnouncePlayTitle(item, 0)} `}</span>
                <span
                  style={{
                    color: ['MES'].includes(this.gMAnnouncePlayTitle(item, 1))
                      ? '#C61818'
                      : '#fff',
                  }}
                >{`${this.gMAnnouncePlayTitle(item, 1)}`}</span>
              </PrePlaySingle>
            ) : (
              <PrePlaySingle
                text={`${
                  item.type.toLowerCase() === 'announce' ? 'anoc' : item.type
                }`}
                backgroundColor={'#231f20'}
              />
            )}
          </PlayTypeDD>
          <InputsWrapper>
            <Row>
              {isGMAnnounce && (
                <SelectTypeLocked title={presetName}>
                  {presetName}
                </SelectTypeLocked>
              )}
              <RowArea key={0}>
                <EditorReadOnly
                  id={editorReadOnly1Announce}
                  className={`${this.reference}-header-preload-readonly`}
                  onClick={this.toggleEditor.bind(
                    this,
                    'header',
                    'editing',
                    `${this.reference}-header-preload`,
                    `${this.reference}-header-preload-readonly`,
                    editorReadOnly1Announce
                  )}
                  style={{
                    color: this.quillHeaderColor,
                    fontFamily: this.quillHeaderFont,
                    paddingLeft: 6,
                  }}
                  isLineHeight={true}
                />
                <Editor
                  // id="announce-editor"
                  id={editor1Announce}
                  className={`${this.reference}-header-preload`}
                  onBlur={this.toggleEditor.bind(
                    this,
                    'header',
                    'locking',
                    `${this.reference}-header-preload`,
                    `${this.reference}-header-preload-readonly`,
                    editor1Announce
                  )}
                  style={{
                    color: this.quillHeaderColor,
                    fontFamily: this.quillHeaderFont,
                  }}
                />
                {this.state.haveUpdated.includes('header') && (
                  <React.Fragment>
                    <DDColor
                      hidden={required}
                      height={h}
                      index={'color-header' + item.index}
                      announcement={item.announcements[0]}
                      clicked={this.toggleEditor.bind(
                        this,
                        'header',
                        'editing',
                        `${this.reference}-header-preload`,
                        `${this.reference}-header-preload-readonly`
                      )}
                      value={this.handleColorValue.bind(this)}
                      defaultColor={this.quillHeaderColor}
                    />
                    <DDFont
                      hidden={required}
                      height={h}
                      index={'font-header' + item.index}
                      announcement={item.announcements[0]}
                      clicked={this.toggleEditor.bind(
                        this,
                        'header',
                        'editing',
                        `${this.reference}-header-preload`,
                        `${this.reference}-header-preload-readonly`
                      )}
                      value={this.handleFontValue.bind(this)}
                      defaultFont={this.quillHeaderFont}
                    />
                  </React.Fragment>
                )}
              </RowArea>

              <RowArea key={1}>
                <EditorReadOnly
                  // locked={required}
                  id={editorReadOnly2Announce}
                  className={`${this.reference}-middle-preload-readonly`}
                  onClick={
                    required
                      ? null
                      : this.toggleEditor.bind(
                          this,
                          'middle',
                          'editing',
                          `${this.reference}-middle-preload`,
                          `${this.reference}-middle-preload-readonly`,
                          editorReadOnly2Announce
                        )
                  }
                  style={{
                    color: this.quillMiddleColor,
                    fontFamily: this.quillMiddleFont,
                    paddingLeft: 6,
                  }}
                  isLineHeight={true}
                  mLeft={0.2}
                />
                <Editor
                  // id="announce-editor"
                  id={editor2Announce}
                  className={`${this.reference}-middle-preload`}
                  onBlur={this.toggleEditor.bind(
                    this,
                    'middle',
                    'locking',
                    `${this.reference}-middle-preload`,
                    `${this.reference}-middle-preload-readonly`,
                    editor2Announce
                  )}
                  style={{
                    color: this.quillHeaderColor,
                    fontFamily: this.quillHeaderFont,
                  }}
                />
                {this.state.haveUpdated.includes('middle') && (
                  <React.Fragment>
                    <DDColor
                      hidden={required}
                      height={h}
                      index={'color-middle' + item.index}
                      announcement={item.announcements[1]}
                      clicked={this.toggleEditor.bind(
                        this,
                        'middle',
                        'editing',
                        `${this.reference}-middle-preload`,
                        `${this.reference}-middle-preload-readonly`
                      )}
                      value={this.handleColorValue.bind(this)}
                      defaultColor={this.quillMiddleColor}
                    />
                    <DDFont
                      hidden={required}
                      height={h}
                      index={'font-middle' + item.index}
                      announcement={item.announcements[1]}
                      clicked={this.toggleEditor.bind(
                        this,
                        'middle',
                        'editing',
                        `${this.reference}-middle-preload`,
                        `${this.reference}-middle-preload-readonly`
                      )}
                      value={this.handleFontValue.bind(this)}
                      defaultFont={this.quillMiddleFont}
                    />
                  </React.Fragment>
                )}
              </RowArea>

              <RowArea key={2} width={'40%'}>
                <EditorReadOnly
                  id={editorReadOnly3Announce}
                  className={`${this.reference}-bottom-preload-readonly`}
                  onClick={this.toggleEditor.bind(
                    this,
                    'bottom',
                    'editing',
                    `${this.reference}-bottom-preload`,
                    `${this.reference}-bottom-preload-readonly`,
                    editorReadOnly3Announce
                  )}
                  style={{
                    color: this.quillBottomColor,
                    fontFamily: this.quillBottomFont,
                    display: 'none',
                  }}
                  mLeft={0.2}
                />
                <Editor
                  //id="announce-editor"
                  id={editor3Announce}
                  className={`${this.reference}-bottom-preload`}
                  onBlur={this.toggleEditor.bind(
                    this,
                    'bottom',
                    'locking',
                    `${this.reference}-bottom-preload`,
                    `${this.reference}-bottom-preload-readonly`,
                    editor3Announce
                  )}
                  style={{
                    color: this.quillBottomColor,
                    fontFamily: this.quillHeaderFont,
                    display: 'none',
                  }}
                />
                <DDSponsorWrapper
                  className={`${this.reference}-sponsor`}
                  style={{
                    display: 'block',
                    marginLeft: '0.2vh',
                  }}
                >
                  <DDAnnounceSponsor
                    height={h}
                    index={`${this.reference}-sponsor`}
                    selectedSponsor={null}
                    value={this.handleSelectedSponsor.bind(this)}
                    expanded={item.sponsorExpanded}
                    forId={editorReadOnly3Announce}
                    PlayStoreSample={this.props.PrePlayStore}
                    sponsorId={item.sponsorId}
                    announceItemOnPlayStack={true}
                    fromStack="Anc_item"
                    type={item ? item.type : ''}
                    subType={item ? item.subType : null}
                    sponsorMetaData={
                      item.sponsor ? item.sponsor.sponsorItem || null : null
                    }
                    pmetadata={
                      item.pmetadata
                        ? item.pmetadata.public || item.pmetadata
                        : null
                    }
                  />
                </DDSponsorWrapper>
              </RowArea>
              <AnnouncementTimer
                item={this.props.item}
                isAnocHasChanges={hasChanges => {
                  this.setState({ announcementHasChanges: hasChanges })
                }}
              />
            </Row>
          </InputsWrapper>
          <LastButtonWrapper>
            <RemoveGoWrapper>
              {this.promptRemove ? (
                <PromptRemoveButton
                  // locked={GameStore.isLockedForAllExecutionType}
                  id={`final-remove-${item.type}-${item.id}`}
                  onClick={this.handlePromptRemoveClick.bind(
                    this,
                    `final-remove-${item.type}-${item.id}`
                  )}
                />
              ) : (
                <RemoveButton
                  // locked={GameStore.isLockedForAllExecutionType}
                  id={`prompt-remove-${item.type}-${item.id}`}
                  onClick={this.handleRemoveClick.bind(
                    this,
                    `prompt-remove-${item.type}-${item.id}`
                  )}
                />
              )}
              <GoButton
                id={`go-button-Announce-${item.id}`}
                locked={!sessionStarted}
                onClick={
                  !sessionStarted
                    ? null
                    : this.handleGoClick.bind(
                        this,
                        item.id,
                        `go-button-Announce-${item.id}`
                      )
                }
                innerRef={ref => (this[`next-play-go-${item.id}`] = ref)}
              />
              <PendingIndicator
                src={PendingIndicatorIcon}
                innerRef={ref =>
                  (this[`next-play-indicator-go-${item.id}`] = ref)
                }
              />
            </RemoveGoWrapper>
            {this.state.announcementHasChanges && (
              <UpdateChangesButton
                onClick={this.handleUpdateChanges.bind(this)}
              />
            )}
          </LastButtonWrapper>
        </Main>
      </Container>
    )
  }
}

const h = 6
let FONT_SIZE = '1.8vh'

const Container = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  opacity: 0;
  animation: ${props => fadeIn} 0.3s forwards;
  margin-top: ${props => 0.1}vh;
  margin-bottom: 0.1;
  z-index: ${props => props.zIndex};
`

const fadeIn = keyframes`
  0%{opacity: 0;}
  100%{opacity: 1}
`

const Main = styled.div`
  width: inherit;
  height: ${props => h}vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
`

const PlayTypeDD = styled.div`
  width: 8.4%;
  height: ${props => h}vh;
  display: flex;
`
const PlayStatusWrapper = styled.div`
  width: 3%;
  height: ${props => h}vh;
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-image: url(${props => props.src});
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: center;
`

const PrePlaySequence = styled.div`
  width: 40%;
  height: ${props => h}vh;
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainlight;
  font-size: ${props => FONT_SIZE};
  color: white;
  line-height: 1;
  border-right: 0.5px solid;
  &:after {
    content: '${props => props.text}';
  }
`

const PrePlaySingle = styled.div`
  width: 60%;
  height: ${props => h}vh;
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  color: white;
  line-height: 1;
  text-transform: uppercase;
  &:after {
    content: '${props => props.text}';
  }
`

const SelectTypeLocked = styled.div`
  width: auto;
  max-width: calc(50ch + 1vh);
  flex-shrink: 0;
  height: ${props => h}vh;
  background-color: #e5e5e5;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  color: #000000;
  text-transform: uppercase;
  display: block;
  text-align: center;
  line-height: ${props => h}vh;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0.5vh;
`

const InputsWrapper = styled.div`
  width: 81.6%;
  height: ${props => h}vh;
`

const Row = styled.div`
  width: 100%;
  height: inherit;
  display: flex;
  flex-direction: row;
`

const RowArea = styled.div`
  width: ${props => props.width || '100%'};
  height: inherit;
  display: flex;
  flex-direction: row;
`

const Editor = styled.div`
  width: 100%;
  height: inherit;
  background-color: #ffffff;
  display: none;
  padding-left: 4px;
`

const EditorReadOnly = styled.div`
  width: 100%;
  height: inherit;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  margin-left: ${props => props.mLeft || ''}vh;
  text-transform: uppercase;
  font-family: pamainlight;
  flex-direction: column;
  align-items: flex-start;
  overflow: auto;
  ms-overflow-style: ${'-ms-autohiding-scrollbar'};
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0.3vh rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
    border-radius: ${props => 1}vh;
  }
  &::-webkit-scrollbar {
    width: ${props => responsiveDimension(0.4)};
    background-color: #f5f5f5;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 0, 0, 0.6);
    &:hover {
      background-color: rgba(255, 0, 0, 1);
    }
    border-radius: ${props => 1}vh;
  }
  padding-left: 8px;
  p {
    margin: auto 0;
  }
  justify-content: ${props => props.isGMAnnounce && 'center'};
  line-height: ${props => props.isLineHeight && 1.6};
`

const AddToStackRemoveWrapper = styled.div`
  width: 75%
  height: inherit;
`

const AddToStackButton = styled.div`
  width: ${props => 15}vh;
  height: inherit;
  background-color: #18c5ff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  -webkit-filter: ${props => (props.locked ? 'grayscale(1)' : 'grayscale(0)')};
  &:after {
    content: 'ADD TO STACK';
    color: white;
  }
`

const GoButton = styled.div`
  width: 25%;
  height: ${props => h}vh;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  -webkit-filter: ${props => (props.locked ? 'grayscale(1)' : 'grayscale(0)')};
  opacity: ${props => (props.locked ? 0.4 : 1)};
  position: relative;
  &:after {
    content: 'GO';
    color: #18c5ff;
  }
`

const xGoButton = styled.div`
  width: ${props => `${h}vh`};
  height: ${props => `${h}vh`};
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  -webkit-filter: ${props => (props.locked ? 'grayscale(1)' : 'grayscale(0)')};
  position: relative;
  &:after {
    content: 'GO';
    color: #18c5ff;
  }
`

const RemoveButton = styled.div`
  width: 75%;
  height: inherit;
  background-color: #18c5ff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  -webkit-filter: grayscale(1);
  opacity: 0.3;
  &:after {
    content: 'REMOVE';
    color: black;
  }
`

const PromptRemoveButton = styled.div`
  width: 75%;
  height: inherit;
  background-color: #18c5ff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  &:after {
    content: 'REMOVE PLAY?';
    color: black;
  }
`

const LastButtonWrapper = styled.div`
  width: 9.5%;
  height: inherit;
  display: flex;
  position: relative; /*added for UpdateButton*/
`

const RemoveGoWrapper = styled.div`
  width: 100%;
  height: inherit;
  display: flex;
  justify-content: space-between;
`

const EndAnnounceButton = styled.div`
  width: 100%;
  height: 100%;
  background-color: #c61818;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:after {
    content: 'END ANNOUNCEMENT';
    color: #ffffff;
  }
`

const DDSponsorWrapper = styled.div`
  width: 100%;
  position: relative;
  display: none;
`
const DDSponsorDrop = styled.div`
  width: 6vh;
  height: ${props => `${h}vh`};
  background-color: #bcbec0;
  background-image: url(${props => (props.locked ? '' : UpArrowIcon)});
  background-repeat: no-repeat;
  background-size: 1.5vh;
  background-position: bottom;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  visibility: ${props => (props.hidden ? 'hidden' : 'visible')};
`

const PendingIndicator = styled.div`
  width: ${props => h}vh;
  height: ${props => h}vh;
  background-color: #000000;
  display: none;
  align-items: center;
  &:after {
    content: '';
    display: block;
    width: ${props => h}vh;
    height: ${props => h}vh;
    background-image: url(${props => props.src});
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
    animation: ${props => pendingRotate} 5s linear infinite;
    transformorigin: center center;
  }
`

const pendingRotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`

const UpdateChangesButton = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #ff0000;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex: 1;
  &:after {
    content: 'update changes';
    font-family: pamainbold;
    font-size: ${props => FONT_SIZE};
    color: #ffffff;
    line-height: 1;
    text-transform: uppercase;
  }
`



// WEBPACK FOOTER //
// src/Components/CommandHost/AnnounceItemPreLoad.js